import React, {useState, useEffect} from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { reduxForm, getFormValues, isInvalid } from 'redux-form';

import {GET_ONE, GET_LIST, UPDATE, provider, history} from '../../_utils';

import ActionsCard from './Actions';
import CardEdit from './CardEdit';
import Integration from './Integration';
import Settings from './Settings';
import Templates from './Templates';
import PhoneBook from './PhoneBook';
import Processing from './Processing';

import { TabPanel, SaveButton, CloseButton, PageHeader, SaveStatus, StatusChip, LoadingStub } from '../../_Components';

const scriptName = (scripts, value) => {
    if (!scripts || !value) return null;
    const found = scripts.find((item) => item._id === value || item.id === value);
    return found ? (found.name || found.title) : null;
};

const CardDataEdit = ({match, initialize, initialized, formValues, invalid, isSaving, dirty}) => {
    const [data, setData] = useState(null);
    const [project, setProject] = useState(null);
    const [fields, setFields] = useState(null);
    const [scripts, setScripts] = useState(null);
    const [queues, setQueues] = useState([]);

    useEffect(() => {
        const persist = { persist: true };
        const  fetchData = async () => {
            const { data } = await provider(
                    GET_ONE,
                    '/cards',
                    match.params.id,
                    persist
            );
            setData(data);
            getProject(data);
            initialize(JSON.parse(JSON.stringify(data)));
        }

        const  getProject = async (data) => {
            const project = await provider(
                GET_ONE,
                '/projects',
                data.project,
                persist
            );
            const fieldOptions = project.data.fields.map( el => { return {id: el.value, name: el.label, type: el.type, combobox: el.combobox }});
            setProject(project.data);
            setFields(fieldOptions);
        }

        const getScripts = async  () => {
            const Scripts = await provider(
                GET_LIST,
                '/scripts',
                {},
                persist
            );
            setScripts(Scripts.data);
        }

        const getQueues = async () => {
            const Queues = await provider(
                GET_LIST,
                '/infra/queues',
                {
                    filter: {},
                    sort: { field: 'name', order: 'ASC' },
                    pagination: { page: 1, perPage: 10000 },
                },
                persist
            );
            setQueues(Queues.data);
        }
        if(!initialized){
            fetchData();
            getScripts();
            getQueues();
        }
    }, [match,initialize, initialized]);


    const save = async () => {
        if (!formValues) return;
        const { status, data } = await provider(UPDATE, '/cards/', { id: formValues._id, data: formValues });
        if (status === 200) {
            initialize(JSON.parse(JSON.stringify(data && data._id ? data : formValues)));
        }
    };

    const close = () =>{
        return history.goBack();
    }

    const phonebookCount = formValues && formValues.transfer && formValues.transfer.departments
        ? formValues.transfer.departments.length
        : 0;
    const actionsCount = formValues && formValues.actions ? formValues.actions.length : 0;
    const integrationCount = formValues && formValues.integration ? formValues.integration.length : 0;
    const templatesCount = formValues && formValues.template ? formValues.template.length : 0;
    const processingCount = formValues && formValues.processing ? formValues.processing.length : 0;
    const currentScript = scriptName(scripts, formValues && formValues.script && formValues.script.default);

    const panels = [
        {
            label: 'Настройки',
            element: <Settings
                        comboboxes={project && project.combobox.filter( ( el ) => el.deleted === false )}
                        scripts={scripts}
                        queues={queues}
                        phoneFields={project && project.fields.filter( ( el ) => el.type === 'phone' )}
                        integration={project && project.settings.integration}
                    />
        },
        {
            label: 'Телефонный справочник',
            count: phonebookCount,
            element: <PhoneBook />
        },
        {
            label: 'Форма',
            count: formValues && formValues.cols ? formValues.cols.length : 0,
            element: <CardEdit
                        data={data}
                        fields={fields}
                        result={(project&&data) && project.combobox.find( ( el ) => el._id === data.result )}
                        task={(project&&data) && project.combobox.find( ( el ) => el._id === data.task )}
                    />
        },
        {
            label: 'Действия',
            count: actionsCount,
            element: <ActionsCard
                        style={{width: '100%'}}
                        fields={fields}
                        project={project}
                        comboboxes={project && project.combobox.filter( ( el ) => el.deleted === false )}
                        result={(project&&data) && project.combobox.find( ( el ) => el._id === data.result )}
                        task={(project&&data) && project.combobox.find( ( el ) => el._id === data.task )}
                        queues={queues}
                    />
        },
        {
            label: 'Обработка',
            count: processingCount,
            element: <Processing project={project} />
        },
        {
            label: 'Интеграция',
            count: integrationCount,
            element: <Integration project={project} />
        },
        {
            label: 'Шаблоны',
            count: templatesCount,
            element: <Templates project={project}/>
        },
    ];

    const header = (
        <PageHeader
            crumbs={[
                { label: 'Проекты', to: '/projects' },
                project ? { label: project.name, to: `/projects/${project._id}` } : null,
                { label: 'Карточки' },
            ].filter(Boolean)}
            title={(formValues && formValues.name) || 'Карточка'}
            chips={(
                <>
                    {formValues && formValues.oldScript ? (
                        <StatusChip tone="mono">скрипт {formValues.oldScript}</StatusChip>
                    ) : null}
                    {currentScript ? (
                        <StatusChip tone="acc">{currentScript}</StatusChip>
                    ) : null}
                </>
            )}
            actions={(
                <>
                    <SaveStatus dirty={!!dirty} />
                    <SaveButton handleSaveClick={save} isSaving={isSaving} disabled={!formValues || !dirty || invalid} />
                    <CloseButton handleCloseClick={close} />
                </>
            )}
        />
    );

    return formValues
        ? <TabPanel header={header} panels={panels} />
        : (
            <div className="pc-page">
                {header}
                <div className="pc-stage">
                    <LoadingStub title="Открываем карточку" />
                </div>
            </div>
        );
}

const mapStateToProps = (state, props) => {
    const formValues = getFormValues('card')(state);
    const { fetch } = state;
    return {
        formValues,
        isSaving: fetch ? (fetch.creat>0 ? true : false) : false,
        invalid: isInvalid('card')(state),
    }
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'card',
    })
);

export default enhance(CardDataEdit);
